import GroupUrlSubmit from './GroupUrlSubmit';
import GroupUrlSubmitPlus from './GroupUrlSubmitPlus';
import ReviewLinks from './ReviewLinks';
import ReviewWholescale from './ReviewWholescale';
import ReviewYotpo from './ReviewYotpo';
import TextSubmit from './TextSubmit';
import TiktokPublish from './TiktokPublish';
import UrlSubmit from './UrlSubmit';
import UrlSubmitPlus from './UrlSubmitPlus';

const index = {
  GroupUrlSubmit,
  GroupUrlSubmitPlus,
  ReviewLinks,
  ReviewWholescale,
  ReviewYotpo,
  TextSubmit,
  TiktokPublish,
  UrlSubmit,
  UrlSubmitPlus,
};

export default index;